import { render, staticRenderFns } from "./AppProfileDeal.vue?vue&type=template&id=55a593de&scoped=true&"
import script from "./AppProfileDeal.vue?vue&type=script&lang=js&"
export * from "./AppProfileDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a593de",
  null
  
)

export default component.exports